import React from 'react';

const SecondSidebarItem = ({ id, title, icon: Icon, children, actions }) => {
    return (
        <div className="flex flex-col border-b border-slate-800/80 bg-slate-900/30">
            {/* Header */}
            <div className="px-5 py-4 bg-slate-900/60 border-b border-white/5 flex items-center justify-between group">
                <div className="flex items-center gap-3 min-w-0">
                    {Icon && (
                        <div className="p-2 bg-primary/10 rounded-xl flex items-center justify-center shrink-0 border border-primary/20 shadow-sm transition-transform group-hover:scale-105">
                            <Icon size={16} className="text-primary" />
                        </div>
                    )}
                    <div className="flex-1 min-w-0">
                        <h3 className="text-[11px] font-black uppercase tracking-[0.1em] text-slate-100/90 truncate">
                            {title}
                        </h3>
                    </div>
                </div>
                {actions && (
                    <div className="flex items-center gap-2">
                        {actions}
                    </div>
                )}
            </div>

            {/* Content Container */}
            <div className="flex-1 overflow-hidden">
                {children}
            </div>
        </div>
    );
};

export default SecondSidebarItem;
